/**
 * CostEvent schema — per-call AI cost telemetry (COST-1).
 * Canonical shape for the cost_events Firestore collection.
 */
import { z } from 'zod';

export const CostEvent = z.object({
  id:            z.string(),           // ULID
  tenantId:      z.string(),
  provider:      z.enum(['anthropic', 'openai', 'google', 'cohere', 'internal']),
  model:         z.string().nullable(),
  purpose:       z.string(),           // e.g. 'aegis-herald', 'kaudit-analysis'
  costCents:     z.number().int().nonnegative(),
  outcome:       z.enum(['success', 'error', 'timeout', 'cancelled']),
  durationMs:    z.number().int().nonnegative().optional(),
  correlationId: z.string().optional(),
  callerSession: z.string().optional(),
  createdAt:     z.string(),           // ISO-8601
}).passthrough();

/** @typedef {import('zod').infer<typeof CostEvent>} CostEventType */
